import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { getAirportByCode } from '../api/searchAirports'
import { convertPassengersQueryStrToObject } from '../helpers/searchQueryParams'
import { SearchForm } from '../components/SearchSideSheet/useSearchForm'

export const useFlightsSearchParams = (): SearchForm | null => {
  const [searchParams] = useSearchParams()

  return useMemo(() => {
    const originCode = searchParams.get('origin')
    const destinationCode = searchParams.get('destination')
    const departing = searchParams.get('departing')
    const passengersQueryStr = searchParams.get('passengers')
    const returning = searchParams.get('returning')
    if (!originCode || !destinationCode || !departing || !passengersQueryStr) return null

    const departureAirport = getAirportByCode(originCode)
    const destinationAirport = getAirportByCode(destinationCode)

    if (!departureAirport || !destinationAirport) return null

    const departingDateData = new Date(departing)
    const returningDateData = returning ? new Date(returning) : undefined
    const passengersData = convertPassengersQueryStrToObject(passengersQueryStr)

    return {
      departure: departureAirport,
      destination: destinationAirport,
      date: { from: departingDateData, to: returningDateData },
      ...passengersData,
    }
  }, [searchParams])
}
